<tg-row class="summary-page-summary-section__header">
  <tg-col md="6" sm="12">
    <p class="p-lead-copy">Summary</p>
  </tg-col>
</tg-row>
<tg-row>
  <tg-col class="summary-page-summary-section__content" sm="6">
    @if (draftData.listingDetails.sellingType === SellingTypeEnum.classified) {
      <span class="summary-page-summary__content-label"
        >
        Total fees to pay
      </span>
    }
    @if (draftData.listingDetails.sellingType === SellingTypeEnum.auction) {
      <span class="summary-page-summary__content-label"
        >
        Total fees to pay*
      </span>
    }
  </tg-col>
  <tg-col sm="6" class="summary-page-summary-section__content">
    <span
      class="summary-page-summary-section__priceDisplay"
      [innerHTML]="packagePrice | currency | tmSupCurrency"
    ></span>
  </tg-col>
</tg-row>
<tg-row>
  <tg-col class="summary-page-summary-section__content" sm="6">
    <span class="summary-page-summary-section__content-label"
      >Your Trade Me balance before fees are deducted</span
      >
    </tg-col>
    <tg-col sm="6" class="summary-page-summary-section__content">
      <span
        class="summary-page-summary-section__priceDisplay"
          [innerHTML]="
                memberBalance | currency | tmSupCurrency
            "
      ></span>
    </tg-col>
  </tg-row>
  @if (draftData.listingDetails.sellingType === SellingTypeEnum.auction) {
    <tg-row
      class="summary-page-summary-section__content--auctionFeeMessage"
      >
      <tg-col md="12">
        *A success fee of 2% applies to all auctions that close above reserve with a winning bid, Buy Now, or fixed price offer. The maximum success fee is $99.
      </tg-col>
    </tg-row>
  }

